<template>
  <div id="GoodsProperty">
    <div v-if="type == -1">
      <div class="GoodsPropertyTitle">产品参数 :</div>
      <div class="goodsDetailProps">
        <div class="propsItem">商品名称:&nbsp;{{ goods.name }}</div>
        <div class="propsItem">店铺名称:&nbsp;{{ goods.storeName }}</div>
        <div class="propsItem">
          价格:&nbsp;{{
            goods.price
              ? `${goods.price.toFixed(2)}元/${goods.unit}`
              : "随行就市"
          }}
        </div>
        <div class="propsItem">
          库存:&nbsp;{{ goods.stockCount }}{{ goods.buyUnit }}
        </div>
        <!-- 1.只有白条有等级 -->
        <div
          class="propsItem"
          v-if="
            (goods.goodsType && goods.goodsType.indexOf('白条') > -1) ||
            (goods.breed && goods.breed.indexOf('白条') > -1)
          "
        >
          等级:&nbsp;{{ getGradeText(goods.grade) }}
        </div>
        <!-- 2.生猪有均重，没有规格 -->
        <div
          class="propsItem"
          v-if="
            (goods.goodsType && goods.goodsType.indexOf('生猪') > -1) ||
            (goods.breed && goods.breed.indexOf('生猪') > -1) ||
            (goods.breed && goods.breed.indexOf('种猪') > -1) ||
            (goods.breed && goods.breed.indexOf('种猪') > -1)
          "
        >
          均重:&nbsp;{{
            goods.avgWeight ? `${goods.avgWeight}kg/头` : goods.spec || "待定"
          }}
        </div>

        <div
          v-if="
            !(
              (goods.goodsType && goods.goodsType.indexOf('生猪') > -1) ||
              (goods.breed && goods.breed.indexOf('生猪') > -1) ||
              (goods.breed && goods.breed.indexOf('种猪') > -1) ||
              (goods.breed && goods.breed.indexOf('种猪') > -1)
            )
          "
          class="propsItem"
        >
          规格:&nbsp;{{ goods.spec }}
        </div>
        <div class="propsItem">分类:&nbsp;{{ goods.goodsType }}</div>
        <!-- 3.肉制品没有品种 -->
        <div
          v-if="
            (goods.breed && goods.breed.indexOf('肉制品') > -1) ||
            (goods.goodsType && goods.goodsType.indexOf('肉制品') > -1)
              ? false
              : true
          "
          class="propsItem"
        >
          品种:&nbsp;{{ goods.breed }}
        </div>
        <div class="propsItem">
          最低购买数量:&nbsp;{{ goods.minBuyCount||1 }}{{ goods.buyUnit }}
        </div>

        <div class="propsItem">
          产地:&nbsp;{{
            isNaN(goods.birthPlace)
              ? goods.birthPlace
              : getCity(goods.birthPlace)
          }}
        </div>
        <div class="propsItem">仓库地址:&nbsp;{{ goods.address }}</div>
        <div v-if="isBeijing" class="propsItem">
          发布日期:&nbsp;{{ getDate(goods.addTime) }}
        </div>
      </div>
      <!-- <div class="goodsMark">备注:&nbsp;{{goods.remark}}</div> -->
      <div v-if="goods.remark" class="propsItem">
        备注:&nbsp;{{ goods.remark }}
      </div>
    </div>
    <div v-else-if="type == 1">
      <div class="GoodsPropertyTitle1">
        {{ `『供应${formateStatus(goods.sdStatus)}』${goods.sdName}` }}
        <div>
          <span class="titleLxr">联系人:{{ goods.realName }}</span>
          <span class="titleLxr">联系电话:{{ formateMobile(goods.telphone) }}</span>
        </div>
      </div>
      <div class="goodsDetailProps">
        <div class="propsItem">商品名称:&nbsp;{{ goods.sdName }}</div>
        <div v-if="goods.storeName" class="propsItem">
          店铺名称:&nbsp;{{ goods.storeName }}
        </div>
        <!-- 3.肉制品没有品种 -->
        <div
          v-if="
            (goods.breed && goods.breed.indexOf('肉制品') > -1) ||
            (goods.goodsType && goods.goodsType.indexOf('肉制品') > -1)
              ? false
              : true
          "
          class="propsItem"
        >
          分类:&nbsp;{{ goods.breed }}
        </div>
        <div class="propsItem">
          最低购买数量:&nbsp;{{ goods.minBuyCount||1 }}{{ goods.buyUnit }}
        </div>
        <div v-if="goods.price" class="propsItem">
          单价:&nbsp;{{
            goods.price
              ? `${goods.price.toFixed(2)}元/${goods.unit}`
              : "随行就市"
          }}
        </div>
        <div v-if="goods.orderPrice" class="propsItem">
          定金:&nbsp;{{ `${goods.orderPrice.toFixed(2)}元/${goods.unit}` }}
        </div>
        <div class="propsItem">
          库存:&nbsp;{{ goods.sdNumber }}{{ goods.buyUnit }}
        </div>
        <!-- 1.只有白条有等级 -->

        <div class="propsItem">
          产地:&nbsp;{{
            isNaN(goods.birthPlace) ? goods.birthPlace : getCity(goods.sdAreaId)
          }}
        </div>
        <div class="propsItem">仓库地址:&nbsp;{{ goods.sdAddress }}</div>
        <div class="propsItem">发布日期:&nbsp;{{ goods.pubTime|formateDate}}</div>
        <div class="propsItem">
          信息有效日期:&nbsp;{{goods.pubTime|formateDate}}
        </div>
       
      </div>
      <!-- <div class="goodsMark">备注:&nbsp;{{goods.remark}}</div> -->
    </div>

       <div v-else-if="type == 2">
      <div class="GoodsPropertyTitle2">
        {{ `『求购${formateStatus(goods.sdStatus)}』${goods.sdName}` }}
        <div>
          <span class="titleLxr">联系人:{{ goods.realName }}</span>
          <span class="titleLxr">联系电话:{{ formateMobile(goods.telphone) }}</span>
        </div>
      </div>
      <div class="goodsDetailProps">
        <div class="propsItem">商品名称:&nbsp;{{ goods.sdName }}</div>
        <div v-if="goods.storeName" class="propsItem">
          店铺名称:&nbsp;{{ goods.storeName }}
        </div>
        <!-- 3.肉制品没有品种 -->
        <div
          v-if="
            (goods.breed && goods.breed.indexOf('肉制品') > -1) ||
            (goods.goodsType && goods.goodsType.indexOf('肉制品') > -1)
              ? false
              : true
          "
          class="propsItem"
        >
          分类:&nbsp;{{ goods.breed }}
        </div>
        <div class="propsItem">
          最低购买数量:&nbsp;{{ goods.minBuyCount||1 }}{{ goods.buyUnit }}
        </div>
        <div v-if="goods.price" class="propsItem">
          单价:&nbsp;{{
            goods.price
              ? `${goods.price.toFixed(2)}元/${goods.unit}`
              : "随行就市"
          }}
        </div>
        <div v-if="goods.orderPrice" class="propsItem">
          定金:&nbsp;{{ `${goods.orderPrice.toFixed(2)}元/${goods.unit}` }}
        </div>
        <div class="propsItem">
          库存:&nbsp;{{ goods.sdNumber }}{{ goods.buyUnit }}
        </div>
        <!-- 1.只有白条有等级 -->

        <div class="propsItem">
          产地:&nbsp;{{
            isNaN(goods.birthPlace) ? goods.birthPlace : getCity(goods.sdAreaId)
          }}
        </div>
        <div class="propsItem">仓库地址:&nbsp;{{ goods.sdAddress }}</div>
        <div class="propsItem">发布时间:&nbsp;{{goods.pubTime|formateDate }}</div>
        <div class="propsItem">
          信息有效时间:&nbsp;{{ goods.pubTime|formateDate}}
        </div>
       
      </div>
      <!-- <div class="goodsMark">备注:&nbsp;{{goods.remark}}</div> -->
    </div>
  </div>
</template>

<script>
import { getDate, getCity, isBeijing ,formateDate2} from "@/api/api";
import {mapState} from 'vuex'

export default {
  props: ["goodsInfo", "type",'index'],
  data() {
    return {
      getDate,
      goods: "",
      getCity,
    };
  },
  computed:{
    ...mapState(['userInfo'])
  },
  created() {
    this.isBeijing = isBeijing;
    this.formateDate2 = formateDate2;
  },
  watch: {
    goodsInfo(val) {
      this.goods = val;
    },
  },
  methods: {
       formateMobile(data) {
      let value = "";
      if (this.userInfo && this.userInfo.access_token) {
        value = data;
      } else {
        value = data.substr(0, 3) + "****" + data.substr(7, 4);
      }
      return value;
    },
    formateStatus(status) {
      if (status == 0) {
        return "";
      } else if (status == 1) {
        return "--现货";
      } else if (status == 2) {
        return "--期货";
      }
    },
    getGradeText(grade) {
      switch (grade) {
        case 1:
          return "一级";
        case 2:
          return "二级";
        case 3:
          return "三级";
        case 4:
          return "四级";
        case 5:
          return "分割级";
        default:
          break;
      }
    },
  },
};
</script>

<style lang='less' scoped>
#GoodsProperty {
  font-size: 14px;
  color: #666;
  // border: 1px solid #eee;
  background-color: #fff;
  padding: 15px;
  .GoodsPropertyTitle{
    height: 40px;
    line-height: 40px;
    color: #999;
    font-size: 13px;
    margin-left: 4px;
  }
  .GoodsPropertyTitle1 {
    height: 40px;
    line-height: 40px;
    margin: 10px 0;
    font-size: 18px;
    color: #009e96;
    margin-left: -5px;
    display: flex;

  }
  .GoodsPropertyTitle2{
        height: 40px;
    line-height: 40px;
    margin: 10px 0;
    font-size: 18px;
    color: #009e96;
    margin-left: -5px;
    display: flex;
  }
  .goodsDetailProps {
    overflow: hidden;
  }
  .propsItem {
    width: 30%;
    margin: 0 5px;
    // background-color: blue;
    height: 26px;
    line-height: 26px;
    float: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
    color: #666;
  }
  .titleLxr {
    margin-left: 30px;
    color: blue;
    font-size: 14px;
    // line-height: 30px;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/GoodsDetail/component/GoodsProperty.vue